import { useMutation } from 'react-query'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { joinAbsRoute } from 'src/common/utils'

import { AppEvents, ROUTES, STORAGE_KEYS } from 'src/constants'
import AuthDataService from 'src/services/auth.service'
import { IFinishUserSignup } from 'src/types'

const useFinsihUserSignup = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const { token } = useParams()

  const referrerId = localStorage.getItem(STORAGE_KEYS.REFERRAL_ID)

  return useMutation(
    async (dto: IFinishUserSignup) => {
      const id = searchParams.get('userId')

      const { buisness, ...rest } = dto

      if (!id && !token) {
        const detail = { message: 'An error has occured. Please try again.' }

        const event = new CustomEvent(AppEvents.HTTP_ERROR, { detail })
        document.dispatchEvent(event)

        return navigate(ROUTES.LOGIN)
      }

      return id
        ? AuthDataService.finishSignup({ ...rest, customer: !buisness, id }, undefined, referrerId)
        : AuthDataService.finishSignup({ ...rest, customer: !buisness }, token, referrerId)
    },
    {
      onSuccess: (data) => {
        if (!data) {
          return navigate(ROUTES.LOGIN)
        }

        if (localStorage.getItem(STORAGE_KEYS.REFERRAL_ID)) {
          localStorage.removeItem(STORAGE_KEYS.REFERRAL_ID)
        }

        localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, data.accessToken)
        localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, data.refreshToken)
        return navigate(
          data?.customer
            ? joinAbsRoute(ROUTES.USER, ROUTES.USER_DASHBOARD)
            : data.accountId
              ? joinAbsRoute(ROUTES.ACCOUNTS, data.accountId, ROUTES.DASHBOARD)
              : data.scannerAccountId
                ? joinAbsRoute(ROUTES.ACCOUNTS, data.scannerAccountId, ROUTES.SCAN_HISTORY)
                : joinAbsRoute(ROUTES.ACCOUNTS),
        )
      },
    },
  )
}

export { useFinsihUserSignup }
